import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBuildings: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconBuildings"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3H15V18.5H16V7H21V18.5H23V20H1V18.5H3V3ZM7 8H11V9.5H7V8ZM7 12H11V13.5H7V12Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBuildings;
